function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelebrationRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-47"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 391.92,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.14,
    y: 389.21,
    width: 46.75,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.8,
    y: 399.65,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.33,
    y: 395.31,
    width: 30.21,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.44,
    y: 395.31,
    width: 19.32,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.35,
    y: 399.53,
    width: 58.56,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.51,
    y: 96.33,
    width: 237.93,
    height: 148.89,
    transform: "translate(416.95 341.55) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.03,
    y: 56.47,
    width: 134.89,
    height: 228.62,
    transform: "translate(379.25 -37.7) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.69 238.22 269.23 103.33 251.94 103.33 275.39 238.22 292.69 238.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.4 238.22 247.95 103.33 240.22 103.33 263.67 238.22 271.4 238.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.56 238.22 210.11 103.33 192.82 103.33 216.27 238.22 233.56 238.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 238.22 166.51 103.33 158.78 103.33 182.23 238.22 189.97 238.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.68,
    y: 170.19,
    width: 134.89,
    height: 1.18,
    transform: "translate(432.9 -91.35) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.75,
    y: 170.19,
    width: 134.89,
    height: 1.18,
    transform: "translate(492.97 -151.41) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.6,
    y: 168.45,
    width: 134.89,
    height: 4.66,
    transform: "translate(435.82 -94.27) rotate(90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.96,
    y: 170.19,
    width: 134.89,
    height: 1.18,
    transform: "translate(375.19 -33.63) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.88,
    y: 168.45,
    width: 134.89,
    height: 4.66,
    transform: "translate(378.1 -36.55) rotate(90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.22,
    y: 170.19,
    width: 134.89,
    height: 1.18,
    transform: "translate(317.44 24.11) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.14,
    y: 168.45,
    width: 134.89,
    height: 4.66,
    transform: "translate(320.36 21.2) rotate(90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.47,
    y: 170.19,
    width: 148.89,
    height: 1.18,
    transform: "translate(259.69 81.86) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.33,86.11H338a1.56,1.56,0,0,0,1.56-1.55h0A1.56,1.56,0,0,0,338,83H65.33a1.56,1.56,0,0,0-1.55,1.56h0A1.56,1.56,0,0,0,65.33,86.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.73,
    y: 80,
    width: 103.46,
    height: 271.67,
    transform: "translate(564.92 431.67) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.64 353.89 302.31 353.89 299.88 82.22 296 82.22 293.64 353.89",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.77 353.89 316.96 353.89 315.78 82.22 313.91 82.22 312.77 353.89",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.5 353.89 272.68 353.89 271.51 82.22 269.64 82.22 268.5 353.89",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.2 353.89 251.38 353.89 250.21 82.22 248.34 82.22 247.2 353.89",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.67,
    y: 80,
    width: 51.73,
    height: 271.67,
    transform: "translate(193.07 431.67) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.13 353.89 106.46 353.89 105.25 82.22 103.31 82.22 102.13 353.89",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.69 353.89 113.78 353.89 113.2 82.22 112.26 82.22 111.69 353.89",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.56 353.89 91.65 353.89 91.06 82.22 90.13 82.22 89.56 353.89",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.91 353.89 81 353.89 80.41 82.22 79.47 82.22 78.91 353.89",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 361.1,
    y: 122,
    width: 68.63,
    height: 85.66,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.13,
    y: 122,
    width: 70.62,
    height: 85.66,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.69,
    y: 134.93,
    width: 73.5,
    height: 59.79,
    transform: "translate(562.27 -232.61) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.31,
    y: 164.55,
    width: 73.5,
    height: 0.56,
    transform: "translate(591.89 -262.23) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.12,
    cy: 153.89,
    r: 8.64,
    transform: "translate(11.59 335.78) rotate(-45)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.31,
    cy: 166.85,
    r: 17.56,
    transform: "translate(-1.61 329.81) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.35,
    cy: 153.89,
    r: 8.64,
    transform: "translate(146.27 492.6) rotate(-76.72)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.68,
    y: 280.36,
    width: 9.38,
    height: 95.62,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.4,
    y: 274.64,
    width: 99.82,
    height: 5.72,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.5,
    y: 375.98,
    width: 87.61,
    height: 6.42,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.06,
    y: 280.36,
    width: 85.88,
    height: 95.62,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.88,
    y: 291.01,
    width: 70.23,
    height: 29.34,
    transform: "translate(803.99 611.36) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.88,
    y: 334.17,
    width: 70.23,
    height: 29.34,
    transform: "translate(803.99 697.67) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.17,
    y: 289.28,
    width: 19.65,
    height: 4.56,
    rx: 1.82,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.17,
    y: 332.44,
    width: 19.65,
    height: 4.56,
    rx: 1.82,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.1,
    cy: 360.84,
    r: 21.56,
    transform: "translate(-55.37 34.79) rotate(-9.22)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.98,
    cy: 355.49,
    r: 26.91,
    transform: "translate(-54.94 29.42) rotate(-9.22)",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-47"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-47",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Confetti--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.61,197.54c-6.61,0-9.72-6.65-9.85-6.93a1.32,1.32,0,0,1,2.39-1.1c0,.09,2.63,5.54,7.66,5.4a1.32,1.32,0,0,1,.07,2.63Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,105.19a12.63,12.63,0,0,1-1.72-.11,1.31,1.31,0,0,1,.39-2.6h0c.06,0,6.08.85,8.72-3.44a1.31,1.31,0,0,1,2.24,1.37C220,104.57,215.45,105.19,213,105.19Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,105.19a12.63,12.63,0,0,1-1.72-.11,1.31,1.31,0,0,1,.39-2.6h0c.06,0,6.08.85,8.72-3.44a1.31,1.31,0,0,1,2.24,1.37C220,104.57,215.45,105.19,213,105.19Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6,155.27A13.78,13.78,0,0,1,57.48,153,1.31,1.31,0,1,1,59,150.87h0c.05,0,5.09,3.41,9.34.7a1.32,1.32,0,1,1,1.42,2.22A9.44,9.44,0,0,1,64.6,155.27Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6,155.27A13.78,13.78,0,0,1,57.48,153,1.31,1.31,0,1,1,59,150.87h0c.05,0,5.09,3.41,9.34.7a1.32,1.32,0,1,1,1.42,2.22A9.44,9.44,0,0,1,64.6,155.27Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.63,120.2A13.87,13.87,0,0,1,400.5,118a1.31,1.31,0,0,1,1.49-2.16h0c.05,0,5.1,3.4,9.35.7a1.31,1.31,0,1,1,1.41,2.21A9.34,9.34,0,0,1,407.63,120.2Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.63,120.2A13.87,13.87,0,0,1,400.5,118a1.31,1.31,0,0,1,1.49-2.16h0c.05,0,5.1,3.4,9.35.7a1.31,1.31,0,1,1,1.41,2.21A9.34,9.34,0,0,1,407.63,120.2Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.81,223.49c-6.13,0-9.47-5.94-9.62-6.21a1.31,1.31,0,0,1,2.3-1.27c0,.08,3,5.32,8,4.81a1.32,1.32,0,0,1,.27,2.62C247.46,223.47,247.13,223.49,246.81,223.49Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.81,223.49c-6.13,0-9.47-5.94-9.62-6.21a1.31,1.31,0,0,1,2.3-1.27c0,.08,3,5.32,8,4.81a1.32,1.32,0,0,1,.27,2.62C247.46,223.47,247.13,223.49,246.81,223.49Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,250.2a1.31,1.31,0,0,1-.31-2.58h0c.06,0,5.93-1.55,6.73-6.53a1.31,1.31,0,1,1,2.59.42c-1.07,6.71-8.38,8.58-8.69,8.66A1.73,1.73,0,0,1,79,250.2Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,250.2a1.31,1.31,0,0,1-.31-2.58h0c.06,0,5.93-1.55,6.73-6.53a1.31,1.31,0,1,1,2.59.42c-1.07,6.71-8.38,8.58-8.69,8.66A1.73,1.73,0,0,1,79,250.2Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,159.05a1.31,1.31,0,0,1-.32-2.59h0c.06,0,5.93-1.54,6.73-6.52a1.32,1.32,0,1,1,2.6.42c-1.08,6.71-8.39,8.58-8.7,8.65A1.1,1.1,0,0,1,371,159.05Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,159.05a1.31,1.31,0,0,1-.32-2.59h0c.06,0,5.93-1.54,6.73-6.52a1.32,1.32,0,1,1,2.6.42c-1.08,6.71-8.39,8.58-8.7,8.65A1.1,1.1,0,0,1,371,159.05Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.73,208.91l-.22,0c-.32-.06-7.74-1.42-9.27-8a1.31,1.31,0,0,1,1-1.58,1.32,1.32,0,0,1,1.58,1c1.14,4.9,7.1,6,7.16,6a1.32,1.32,0,0,1-.23,2.61Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.29,257.12a9.6,9.6,0,0,1-6.28-2.21,1.31,1.31,0,1,1,1.68-2c3.87,3.22,9.3.52,9.36.49a1.31,1.31,0,0,1,1.2,2.34A14.24,14.24,0,0,1,401.29,257.12Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,93a1.29,1.29,0,0,1-.65-.17c-.27-.15-6.8-3.93-6-10.68a1.31,1.31,0,0,1,2.61.3c-.57,5,4.67,8.07,4.72,8.1A1.31,1.31,0,0,1,340,93Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.79,98.33a1.31,1.31,0,0,1-.11-2.62c5-.44,7-6.18,7-6.24a1.31,1.31,0,0,1,2.49.81c-.09.31-2.49,7.46-9.26,8Z",
    style: {
      fill: "#F15E22"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.36,137.9c-3.55,1.66-6.68,9.64-5.66,21.1s-22.72,3.42-25.95,16.26c-5.83,23.24,33.26,37.21,49.92,23.24,10.31-8.64,20-37.12,18.58-52.66C211.73,129.13,185.81,117.92,176.36,137.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87,167.22c.44-.13,1.08-.32,1.63-.5l1.72-.58c1.15-.4,2.29-.84,3.42-1.31a64.11,64.11,0,0,0,6.58-3.15A40.93,40.93,0,0,0,238.33,153c2.83-3.36,4.86-7.94,6.45-12.64.81-2.36,1.49-4.79,2.07-7.26s1.13-5,1.55-7.43l4.08.25A73.91,73.91,0,0,1,250.73,142a53.12,53.12,0,0,1-2.41,7.94,33,33,0,0,1-4.17,7.65,44.12,44.12,0,0,1-12.86,11.15,63.25,63.25,0,0,1-7.44,3.76c-1.28.54-2.57,1-3.89,1.49-.65.23-1.31.45-2,.65s-1.3.39-2.12.59Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.46,127.29l1.7-6.11-6.75.52s-.48,4,1.85,6.41Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.17 114.07 249.01 115.68 247.41 121.7 254.16 121.18 255.17 114.07",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.23,168.78c3.11-2.83,11-5,11-5l8.65,13s-9.87,6.59-14.06,5.06C207.46,180.32,203.33,171.41,206.23,168.78Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.74 353.69 183.13 359.61 198.6 348.59 193.21 342.67 177.74 353.69",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.32 377.08 154.55 380.67 165.18 365.08 157.95 361.49 147.32 377.08",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.7,379.78l-5.58-7.15a.64.64,0,0,0-.83-.17l-6.29,3.6a1.29,1.29,0,0,0-.34,1.9c2,2.46,3.07,3.55,5.53,6.7,1.5,1.93,4.56,6.43,6.64,9.1s4.84.76,4.21-.54c-2.82-5.83-3-9.29-2.9-12.07A2.09,2.09,0,0,0,155.7,379.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.74,359.72l-3.68-8.84a.77.77,0,0,0-.82-.47l-7.8,1a1.18,1.18,0,0,0-.95,1.66c1.34,3.07,2.15,4.5,3.77,8.39,1,2.39,3.32,8.67,4.69,12s4.89,2.54,4.63,1.08c-1.17-6.54-.77-10.76.2-13.33A1.94,1.94,0,0,0,184.74,359.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.59 348.59 190.62 354.27 184.59 348.81 193.2 342.67 198.59 348.59",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.95 361.49 165.18 365.08 159.69 373.12 152.46 369.52 157.95 361.49",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.12,169.79s.24-.36-4.14,47.42l-32.7,2.29c-.38-13.34.62-22.76-5.61-50.17a96.2,96.2,0,0,1,13.93-1.76,103.45,103.45,0,0,1,14.88.08C209.87,168.26,217.12,169.79,217.12,169.79Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.13,177.25c-2.43-1.12-4.56-2.32-6.77-3.59s-4.3-2.63-6.38-4.07a76.9,76.9,0,0,1-11.75-9.82l-1.32-1.43-.34-.36a8.88,8.88,0,0,1-.55-.7,8.74,8.74,0,0,1-.8-1.4,12.62,12.62,0,0,1-1-4.94,32.13,32.13,0,0,1,1.08-8,74.57,74.57,0,0,1,5.26-14.16l3.82,1.48c-.59,2.27-1.15,4.63-1.65,6.94s-.92,4.64-1.2,6.92a29.49,29.49,0,0,0-.26,6.48,6,6,0,0,0,.56,2.16c0,.07.1.15.13.16s0,0,0,0l.31.29,1.23,1.17a85.84,85.84,0,0,0,11,8.45c1.95,1.29,4,2.47,6,3.66s4.15,2.32,6.1,3.31Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.54,171.16c-3.71-5.17-11-5.09-11-5.09l-8.79,13s9.81,6.68,14,5.19C186.19,182.68,189.83,174.34,187.54,171.16Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.48,167.65l-14.88-.08c-2.28.92-3.6,6.85,11.5,11.87C210.57,173.49,205,168.2,203.48,167.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.16,150.82c.91,4.79,1.8,13.57-1.56,16.75,0,0,1.3,4.87,11.5,11.87,7.15-7.17,3.38-11.79,3.38-11.79-5.33-1.31-5.17-5.27-4.22-9Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,198.38h-.16a2,2,0,0,1-1.83-2.15c.36-4.46-3-7.83-6.86-11.74-4.43-4.47-9.46-9.54-9.66-17.43a2,2,0,0,1,4-.1c.16,6.3,4.4,10.58,8.5,14.72s8.51,8.58,8,14.87A2,2,0,0,1,221,198.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.77,208.5a2,2,0,0,1-.48-.06,2,2,0,0,1-1.46-2.42c1.93-7.84-.6-14-3.28-20.48-2.4-5.82-4.88-11.84-3.68-18.88a2,2,0,0,1,3.94.68c-1,5.9,1.15,11.14,3.43,16.68,2.68,6.49,5.71,13.85,3.47,23A2,2,0,0,1,191.77,208.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.38,157l-4,.47a9.11,9.11,0,0,0,1.14,3.05c.79,1.19,2.55,1.71,4.29,1.76a13.49,13.49,0,0,1,.5-3.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.31,146c2.93,7.46,4,10.68,9.11,13.34,7.68,4,16.2-1.21,15.56-9.39-.57-7.37-5.26-18.33-13.69-18.95A10.93,10.93,0,0,0,181.31,146Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.34,129.92c5.69,3.5.82,24.09-8.81,23S180.93,124.75,189.34,129.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.13,130c-4.29,2.85-1.36,7.81,13.1,4.87C202.23,134.86,196.25,125.26,189.13,130Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.35,153.25a5.88,5.88,0,0,0,3.24,3.08c1.93.72,3.06-1,2.68-2.87-.35-1.71-1.77-4.16-3.77-4.06A2.63,2.63,0,0,0,182.35,153.25Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,217.21s17.5,57.13,18.91,81.71c1.46,25.57-36.51,55.91-36.51,55.91l-9.45-10.37s30.85-26.2,26.62-45.18C206.72,273.12,189,218.89,189,218.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.09,235.91c-1.6-5-5.16-1.64-6.4,3.66,2.47,8,5.33,17.36,8.05,26.73C204.79,258,205.22,245.71,202.09,235.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.39 343.96 195.38 356.33 200.5 353.5 187.83 339.71 183.39 343.96",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.35,217.82s-5,56-10,87.19c-4.05,25.2-31.56,66.36-31.56,66.36l-10.08-4.69s18.49-44.07,21.37-61.2c9.24-54.83-3.24-70.65,6.21-86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152 366.79 163.37 372.37 167.1 367.74 153.8 361.47 152 366.79",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.66,217.62l-1.27,3c-.1.23.18.45.56.42l34.3-2.4c.29,0,.53-.18.53-.37l.09-3c0-.2-.26-.35-.58-.33l-33.12,2.32A.57.57,0,0,0,179.66,217.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.36,221l-.88.06c-.18,0-.32-.07-.32-.18l.15-3.83c0-.11.16-.22.33-.23l.89-.06c.18,0,.32.07.31.18l-.15,3.83C184.69,220.9,184.54,221,184.36,221Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.78,219.16l-.89.06c-.18,0-.32-.07-.31-.18l.15-3.83c0-.11.15-.21.33-.23l.88-.06c.18,0,.32.07.32.18l-.15,3.84C211.1,219.05,211,219.15,210.78,219.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.57,220.09l-.89.06c-.17,0-.31-.07-.31-.18l.15-3.84c0-.11.15-.21.33-.22l.89-.06c.17,0,.31.07.31.18l-.15,3.83C197.9,220,197.75,220.07,197.57,220.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.36,143.2c-.48.16-.68.88-.44,1.62l1.75-.56C194.43,143.52,193.84,143,193.36,143.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,140.78c-.49.16-.69.89-.45,1.63l1.76-.57C202,141.1,201.43,140.63,201,140.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.75,140.89l1.61-1.08S201.9,141.49,200.75,140.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,143.8a17.3,17.3,0,0,0,3.48,3.24,2.79,2.79,0,0,1-2.07,1.13Z",
    style: {
      fill: "#630f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.12,151.28a.2.2,0,0,0,.06-.21.19.19,0,0,0-.24-.12,5.18,5.18,0,0,1-4.62-.62.19.19,0,0,0-.27,0,.18.18,0,0,0,0,.27,5.44,5.44,0,0,0,5,.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.83,142.75a.36.36,0,0,0,.11-.16,3,3,0,0,1,1.94-2,.38.38,0,1,0-.18-.74,3.81,3.81,0,0,0-2.48,2.46.38.38,0,0,0,.24.48A.36.36,0,0,0,190.83,142.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.81,137.81a.12.12,0,0,0,.05-.05.38.38,0,0,0-.06-.54,3.82,3.82,0,0,0-3.41-.75.38.38,0,0,0-.24.49.39.39,0,0,0,.48.24,3,3,0,0,1,2.69.62A.38.38,0,0,0,202.81,137.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.75,131.73a1.36,1.36,0,0,1-.69-.19L131.64,112.8a1.32,1.32,0,0,1,1.38-2.24l30.42,18.74a1.31,1.31,0,0,1-.69,2.43Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.53,114.87c1.71-.07,3.47-.15,3.7-1.69s-1.42-2.13-3-2.71l-.43-.16c0-.15-.07-.3-.11-.44l.35-.39c1.12-1.24,2.29-2.52,1.38-3.74s-2.47-.5-4,.21l-.47.22c-.13-.09-.26-.16-.4-.24s0-.32,0-.46c-.08-1.7-.16-3.46-1.69-3.69s-2.13,1.42-2.71,3c-.05.13-.1.28-.16.43l-.45.11-.38-.34c-1.24-1.13-2.52-2.29-3.74-1.39s-.5,2.47.21,4l.22.47a4.11,4.11,0,0,0-.24.39l-.46,0c-1.7.08-3.47.16-3.7,1.7s1.43,2.13,3,2.71l.43.16c0,.15.07.3.11.44-.12.14-.24.28-.35.39-1.12,1.24-2.28,2.51-1.38,3.74s2.47.49,4-.21l.48-.22.39.24c0,.16,0,.32,0,.46.08,1.7.16,3.46,1.69,3.69s2.14-1.42,2.72-3c0-.12.1-.27.15-.43a3.69,3.69,0,0,0,.45-.11l.39.35c1.23,1.12,2.51,2.29,3.74,1.39s.49-2.47-.22-4c-.06-.13-.14-.3-.21-.47l.24-.39Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.53,114.87c1.71-.07,3.47-.15,3.7-1.69s-1.42-2.13-3-2.71l-.43-.16c0-.15-.07-.3-.11-.44l.35-.39c1.12-1.24,2.29-2.52,1.38-3.74s-2.47-.5-4,.21l-.47.22c-.13-.09-.26-.16-.4-.24s0-.32,0-.46c-.08-1.7-.16-3.46-1.69-3.69s-2.13,1.42-2.71,3c-.05.13-.1.28-.16.43l-.45.11-.38-.34c-1.24-1.13-2.52-2.29-3.74-1.39s-.5,2.47.21,4l.22.47a4.11,4.11,0,0,0-.24.39l-.46,0c-1.7.08-3.47.16-3.7,1.7s1.43,2.13,3,2.71l.43.16c0,.15.07.3.11.44-.12.14-.24.28-.35.39-1.12,1.24-2.28,2.51-1.38,3.74s2.47.49,4-.21l.48-.22.39.24c0,.16,0,.32,0,.46.08,1.7.16,3.46,1.69,3.69s2.14-1.42,2.72-3c0-.12.1-.27.15-.43a3.69,3.69,0,0,0,.45-.11l.39.35c1.23,1.12,2.51,2.29,3.74,1.39s.49-2.47-.22-4c-.06-.13-.14-.3-.21-.47l.24-.39Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.67,132.05l-1.25-8,8.16,4a7.07,7.07,0,0,1-2,3.53,3.3,3.3,0,0,1-3.37,1Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157 120.13 161.18 123.8 160.58 128 152.42 124.04 157 120.13",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.32,383.61a2.12,2.12,0,0,0,.24-.2.64.64,0,0,0,.19-.63c-.24-1-3-2-3.31-2.07a.17.17,0,0,0-.2.05.19.19,0,0,0,0,.21c.45,1,1.35,2.64,2.36,2.81A1,1,0,0,0,158.32,383.61Zm-2.57-2.38c1.09.41,2.5,1.11,2.63,1.64a.28.28,0,0,1-.1.27.72.72,0,0,1-.65.27C157.08,383.31,156.4,382.51,155.75,381.23Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.83,380.94a.63.63,0,0,0,.17-.15.66.66,0,0,0,0-.84,1,1,0,0,0-.7-.48c-1.15-.21-3,1.21-3.07,1.27a.2.2,0,0,0-.07.18.21.21,0,0,0,.11.15A5.06,5.06,0,0,0,158.83,380.94Zm-3-.15a4.21,4.21,0,0,1,2.41-.94.58.58,0,0,1,.44.3c.13.21.07.32,0,.39-.36.43-2,.51-2.91.28Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.92,364.25a3.13,3.13,0,0,0,1.13,1.56,1.17,1.17,0,0,0,1,.09.55.55,0,0,0,.39-.42c.21-1-2.41-3.47-2.94-4a.2.2,0,0,0-.22,0,.18.18,0,0,0-.09.2A12.08,12.08,0,0,0,184.92,364.25ZM187,365a.7.7,0,0,1,.07.37c0,.05,0,.1-.14.14a.83.83,0,0,1-.72-.06c-.61-.36-1.17-1.56-1.53-3.26A12.1,12.1,0,0,1,187,365Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.23,361.75a.21.21,0,0,0,0,.06c.82.83,3.27,2.17,4.06,1.71.17-.1.35-.32.21-.8-.51-1.84-4-1.26-4.17-1.23a.18.18,0,0,0-.15.13A.2.2,0,0,0,184.23,361.75Zm3.9.95.05.12c0,.2,0,.32,0,.37-.46.26-2.31-.6-3.29-1.38C185.71,361.72,187.69,361.64,188.13,362.7Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.16,143.31l1.61-1.09S194.31,143.91,193.16,143.31Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-47"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "323.89 405.27 316.14 405.28 314.05 387.34 321.8 387.33 323.89 405.27",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.6 371.97 384.73 377.04 371.44 364.81 377.3 359.74 390.6 371.97",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.59,376.84l7.14-6.18a.65.65,0,0,1,.83,0L397,375a1.19,1.19,0,0,1,0,1.82c-2.33,1.95-4.12,3.26-7,5.76-1.78,1.54-7,6.38-9.46,8.51s-4.79-.12-4-1.22c3.7-4.92,6-9.28,6.36-11.87A2,2,0,0,1,383.59,376.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.19,404.38h8.47a.68.68,0,0,1,.66.53l1.54,6.89a1.13,1.13,0,0,1-1.11,1.38c-3.06-.05-7.47-.22-11.31-.22-4.48,0-7.11.12-12.37.13-3.18,0-4.07-3.21-2.74-3.5,6.06-1.34,9.76-1.35,15-4.59A3.58,3.58,0,0,1,316.19,404.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,182.51c-1.56-.6-2.9-1.15-4.3-1.79s-2.75-1.27-4.11-1.94q-4.07-2-8-4.46A75.34,75.34,0,0,1,267,169c-.61-.5-1.23-1-1.83-1.51l-1.78-1.63c-.59-.54-1.15-1.16-1.72-1.74-.29-.32-.54-.55-.87-.93s-.65-.75-.94-1.13a24.42,24.42,0,0,1-2.77-4.66,36.46,36.46,0,0,1-1.77-4.65,56.78,56.78,0,0,1-2-9.18,85.29,85.29,0,0,1-.45-18.06l5.82,0c.4,2.71.82,5.56,1.37,8.3s1.13,5.48,1.84,8.12a57.93,57.93,0,0,0,2.54,7.57,21.72,21.72,0,0,0,3.53,6l.49.5c.15.16.45.4.67.6.48.41.92.84,1.43,1.23,1,.8,2,1.59,3.12,2.35,2.16,1.5,4.44,2.93,6.82,4.27s4.81,2.61,7.28,3.81c1.24.61,2.49,1.21,3.74,1.77s2.56,1.15,3.68,1.63Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.24,189.11a90.53,90.53,0,0,1-12.46-9.32L282.87,164a144.21,144.21,0,0,0,17.49,3.82C310.11,169.08,299.19,193.25,292.24,189.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.89,126.87l.55-9.87-8.2,2.63s-1.91,7.07,3.41,8.93Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.45 111.69 251.68 114.51 251.24 119.63 259.44 117 258.45 111.69",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.06 387.34 315.13 396.59 322.88 396.58 321.81 387.33 314.06 387.34",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.31 359.74 371.44 364.81 378.3 371.11 384.16 366.04 377.31 359.74",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.16,167.5a4.16,4.16,0,0,0-4.06-4.29c-22.12-.41-36.51,5.79-37.5,6.19a2.34,2.34,0,0,0-1.43,1.77c-.92,5.54-3.53,28.76,9.26,65.1l41-5.87C336.88,224.35,329.24,196.59,330.16,167.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,166.61c-2.43,3.25-3.53,10.74,4.52,16.22,9.9-7.39,15-15.34,16.51-19.48A102.82,102.82,0,0,0,297,166.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.16,169.65a2,2,0,0,1-2-2c0-1.65,1.43-3.07,2.64-4,4.06-3,12-5.29,22-2.4a2,2,0,0,1-1.11,3.84c-11.6-3.35-18.75,1.41-19.52,2.78A2,2,0,0,1,295.16,169.65Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.78,144.34c-.3,5.77.07,16.21,4.53,19.39-2.62,3.47-6.11,7.54-12.74,8.73-4,.71-5.37-.77-5.54-2.64a4.81,4.81,0,0,1,2.44-4.49c4.31-2.5,3.45-6.52,1.9-10.32Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.55,215.53a1.92,1.92,0,0,1-.66-.12,2,2,0,0,1-1.22-2.55,5.43,5.43,0,0,0-.16-4.37l-.21-.57a6.64,6.64,0,0,0-1.34-1.8,6.5,6.5,0,0,1-1.71-8.05,5.39,5.39,0,0,0,.43-1.8,6.68,6.68,0,0,0-.91-2,7.91,7.91,0,0,1-1.41-4,7.81,7.81,0,0,1,1.57-4.14,5.43,5.43,0,0,0,.8-1.5,4,4,0,0,0-.32-1.62,6,6,0,0,1-.34-3.6,6.58,6.58,0,0,1,2.38-3.4,3.74,3.74,0,0,0,.83-.87,2.61,2.61,0,0,0,0-1.48,4.58,4.58,0,0,1,.45-3.43c.7-1.1.63-1.38.57-1.61a3.4,3.4,0,0,1-.13-1.08,2,2,0,0,1,4,0l0,.06c.28,1.13.36,2.48-1,4.69a6.1,6.1,0,0,0,.09.7,5.55,5.55,0,0,1-2.15,6c-.64.56-1,.9-1.14,1.39a2.84,2.84,0,0,0,.27,1.34,7.35,7.35,0,0,1,.49,3.37,7.75,7.75,0,0,1-1.4,3.17,4.82,4.82,0,0,0-.94,2,5.57,5.57,0,0,0,.87,1.95,9.3,9.3,0,0,1,1.43,3.56,8.27,8.27,0,0,1-.61,3.52,5,5,0,0,0-.45,2.27,5.64,5.64,0,0,0,1.33,1.83,9.67,9.67,0,0,1,2.16,3.18l.18.52a9.26,9.26,0,0,1,.17,7.05A2,2,0,0,1,294.55,215.53Zm2.61-47.78Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.79,167.17c1.09,1,2,1.84,2.92,2.8s1.82,1.89,2.71,2.85c1.78,1.92,3.46,3.94,5.08,6a65,65,0,0,1,8.41,13.92,41.54,41.54,0,0,1,1.46,4.07c.21.7.39,1.43.56,2.17l.06.27.09.47c.06.31.09.64.12,1a9.84,9.84,0,0,1-.06,2,10,10,0,0,1-1.07,3.42,13.28,13.28,0,0,1-1.69,2.48,18,18,0,0,1-3.71,3.22,34.13,34.13,0,0,1-7.54,3.7c-1.26.46-2.53.85-3.81,1.18s-2.52.64-3.91.87l-1.8-5.53c1-.56,2.07-1.15,3.08-1.75s2-1.23,3-1.86a36.91,36.91,0,0,0,5.23-4,10.77,10.77,0,0,0,1.63-2c.35-.57.32-.95.22-.83a.23.23,0,0,0,0,.1s0,0,0,0,0,0,0,0l-.06-.18c-.15-.46-.29-.93-.49-1.41a28.46,28.46,0,0,0-1.27-2.86,46.87,46.87,0,0,0-3.42-5.69c-1.27-1.88-2.67-3.72-4.15-5.52s-3-3.57-4.61-5.32c-.79-.87-1.6-1.72-2.42-2.56s-1.68-1.72-2.41-2.42Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.21,163.38c4.52.67,11.61,12,11.61,12l-11.51,15.43s-6.14-5.85-7.93-11C316,169.93,318.33,162.08,327.21,163.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.18,202.22a2,2,0,0,1-1.71-1,8.1,8.1,0,0,1-.86-4.36,5.43,5.43,0,0,0-.16-1.85,6.48,6.48,0,0,0-1.49-1.62,7.88,7.88,0,0,1-2.59-3.34,7.69,7.69,0,0,1,.19-4.42,5.6,5.6,0,0,0,.29-1.68,6.52,6.52,0,0,0-1.08-1.89,6,6,0,0,1-.33-8,5.77,5.77,0,0,0,.65-1.31,6.61,6.61,0,0,0-.54-2.2,6.4,6.4,0,0,1-.56-3.8,9.19,9.19,0,0,1,2.66-4.82l.13-.13a2,2,0,0,1,2.88,2.77l-.23.23a5.42,5.42,0,0,0-1.57,2.93,9.11,9.11,0,0,0,.45,1.47,9.36,9.36,0,0,1,.77,3.84,7.15,7.15,0,0,1-1.19,3.05,4.56,4.56,0,0,0-.83,2,5.9,5.9,0,0,0,1,1.7,9.24,9.24,0,0,1,1.73,3.41,7.72,7.72,0,0,1-.33,3.45,5,5,0,0,0-.27,2.2,5.74,5.74,0,0,0,1.45,1.58,9.4,9.4,0,0,1,2.47,2.94,8.13,8.13,0,0,1,.52,3.53,5.3,5.3,0,0,0,.29,2.3,2,2,0,0,1-.69,2.74A2,2,0,0,1,321.18,202.22Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.94,148.69,302.38,155a18.31,18.31,0,0,1,1,3c2.34-.69,5.25-3.78,5.15-6.32A8.53,8.53,0,0,0,307.94,148.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.25,127.93c-2.47,4.3-.89,10.42-.89,10.42a4.43,4.43,0,0,0,4.49.2l-.7-11.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.72,138.85c-1.89,7.46-2.62,11.92-7.16,15.07-6.83,4.74-15.49-.48-15.86-8.35-.34-7.09,2.81-18.09,10.77-19.69A10.48,10.48,0,0,1,315.72,138.85Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.94,147.53l-.27,0-16.95-3.59a3.55,3.55,0,1,1,1.47-6.95,1.3,1.3,0,0,1,1,1.55,1.31,1.31,0,0,1-1.55,1,.87.87,0,0,0-.7.13.92.92,0,0,0-.4.58,1,1,0,0,0,.13.7,1,1,0,0,0,.58.4l16.95,3.59a1.31,1.31,0,0,1-.27,2.59Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.87,147.83l-2.05-.44.65-3,2,.43a1.56,1.56,0,0,1,1.2,1.85h0A1.58,1.58,0,0,1,293.87,147.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.09,134.75c0-2.84-2.14-4.91-9.28-4.36-5.83.44-8.67-2.28-7-6.07,4.72,2.46,3.94-.76,12.94-1.15s11.61,3,12.56,8.27c5.51,8.17-4,11.56-4,11.56l-3.72,3.25a4.42,4.42,0,0,1-4.28-1.37S307.58,138.25,311.09,134.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.53,121.76l-.23.12a1.38,1.38,0,0,0-.08,2.39l20.88,12.91a1.38,1.38,0,0,0,2.09-1h0a3.33,3.33,0,0,0-1.54-3.33l-17.8-11A3.34,3.34,0,0,0,301.53,121.76Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.29,123.14l5.34-7.82a1.06,1.06,0,0,1,1.42-.31l14.74,8.83a1.05,1.05,0,0,1,.3,1.55l-6.39,8.44Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.29 123.14 307.42 119.33 323.88 130.21 320.7 133.83 305.29 123.14",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.29 123.14 307.42 119.33 323.88 130.21 320.7 133.83 305.29 123.14",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.67,148a6.79,6.79,0,0,1-5,1.08c-2.27-.44-2.27-2.74-.7-4.37,1.41-1.47,4.3-3,6.12-1.73S318.48,146.75,316.67,148Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.22,394.81l13.12,0s-2.06-46.66-4.89-70.64c-.86-7.3.07-17.3.16-28.47.12-14.07.77-29.4,1.41-41.43.68-12.67,1.25-21.8,1.25-21.8l-26.84,3.83s-2.66,66.43,1.51,89.71C302.28,350.19,312.22,394.81,312.22,394.81Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.61,295.67c.12-14.07.77-29.4,1.41-41.43l-4-5.35C313.08,258.14,316.51,282.77,320.61,295.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.22,234.44s16.67,65.83,24.59,87.12c8.67,23.3,40.6,50.54,40.6,50.54l8.07-8.88s-16.89-26.33-29.34-51.66c-5.95-32.89-15.67-81.16-15.67-81.16Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.33 373.44 385.98 362.51 382.71 358.74 368.36 370.71 373.33 373.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.57 395.11 326.21 395.09 326.2 390.04 308.73 389.8 310.57 395.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.2,137.39c-.5-.15-1.09.33-1.33,1.08l1.78.57C304.89,138.29,304.69,137.55,304.2,137.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.4,135.92c-.51,0-1,.58-1,1.37l1.86.12C297.29,136.62,296.92,136,296.4,135.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.09,138.2a22.47,22.47,0,0,1-3.93,4.7A3.62,3.62,0,0,0,298,144Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.74,136.59a.41.41,0,0,0,.19,0,.37.37,0,0,0,.24-.46,3.63,3.63,0,0,0-2.28-2.45.35.35,0,0,0-.45.25.36.36,0,0,0,.25.45h0a2.92,2.92,0,0,1,1.78,2A.39.39,0,0,0,306.74,136.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.09,134.87a.37.37,0,0,0,.33-.11,2.93,2.93,0,0,1,2.45-1,.37.37,0,0,0,.42-.31.36.36,0,0,0-.3-.41,3.64,3.64,0,0,0-3.11,1.24.36.36,0,0,0,0,.52A.41.41,0,0,0,294.09,134.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.49,379.58a9.37,9.37,0,0,0,1.36-1.55.18.18,0,0,0,0-.2.16.16,0,0,0-.18-.09c-.32,0-3.17.47-3.54,1.38a.62.62,0,0,0,.08.61,1.07,1.07,0,0,0,.9.51A2.27,2.27,0,0,0,382.49,379.58Zm.8-1.4c-.83,1.07-1.63,1.69-2.17,1.69a.71.71,0,0,1-.6-.36.22.22,0,0,1,0-.24C380.66,378.8,382.15,378.38,383.29,378.18Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.82,378.07a.24.24,0,0,0,.06-.09.21.21,0,0,0,0-.19c-.07-.07-1.6-1.7-2.74-1.69a1,1,0,0,0-.74.33h0a.62.62,0,0,0-.14.76c.41.78,2.64,1.1,3.52.92Zm-3.14-1.44a.62.62,0,0,1,.42-.15c.73,0,1.73.85,2.21,1.3-1,.05-2.53-.31-2.78-.77,0-.05-.07-.15.09-.32h0Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.43,405.46a.18.18,0,0,0,.12-.15.17.17,0,0,0-.09-.19c-.36-.18-3.47-1.76-4.41-1.23a.58.58,0,0,0-.31.49h0a1,1,0,0,0,.35.89c.85.75,3.07.44,4.32.19Zm-4.14-1.28c.59-.2,2.28.44,3.51,1-1.71.29-3,.22-3.47-.21a.65.65,0,0,1-.22-.59.21.21,0,0,1,.12-.19Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.43,405.46l.05,0a.21.21,0,0,0,.08-.17c0-.08-.23-2.17-1.21-3a1.33,1.33,0,0,0-1-.31h0c-.51,0-.65.31-.68.51-.14.88,1.71,2.55,2.65,3A.2.2,0,0,0,315.43,405.46Zm-2.25-3.09.19,0h0a.94.94,0,0,1,.74.24,4.27,4.27,0,0,1,1,2.38c-.95-.57-2.22-1.88-2.13-2.41C313,402.51,313,402.42,313.18,402.37Zm.17-.22h0Z",
    style: {
      fill: "#F15E22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.55,211.54l-7.46,2.36,5.79,5.76s6.76-2.93,4.64-5.91Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.02 220.48 323.33 223.7 326.88 219.66 321.09 213.9 318.02 220.48",
    style: {
      fill: "#ffc3bd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrationRafiki);
export default __webpack_public_path__ + "static/media/Celebration-rafiki.51b6097e2da1edd988b98b7a9d00fb51.svg";
export { ForwardRef as ReactComponent };